export const getters = {
  getResultById: (state) => (moduleId) => {
    return state.finishedModules.filter(
      (finishedModule) => finishedModule.comp_comp_id === moduleId
    );
  },

  texts: (state) => (moduleName) => {
    const { language } = state;
    const moduleTexts = state.texts[moduleName];

    if (!moduleTexts) {
      return {};
    }
    return Object.keys(moduleTexts).reduce((acc, variableName) => {
      acc[variableName] = moduleTexts[variableName][language];
      return acc;
    }, {});
  },
  getFinishedModuleContainers: (state) => {
    return state.moduleContainers.filter((container) => {
      return container.isFinished;
    });
  },
};
